import { Provider } from '@ipensii/shared/domain-shared';

export interface ProviderState {
  providers: Array<Provider>;
  error?: Error;
}

export const initialProviderState: ProviderState = { providers: [] };
